import React, { useState } from 'react';
import { Grid, ListItem, Paper, Tooltip, makeStyles } from "@material-ui/core"
import NotInterestedIcon from '@material-ui/icons/NotInterested';
import CreateIcon from '@material-ui/icons/Create';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import CalendarViewDayIcon from '@material-ui/icons/CalendarViewDay';
import { useHistory } from 'react-router-dom';
const useStyles = makeStyles((theme) => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },
  box: {
    display: "flex",
  },
  spreadBox: {
    justifyContent: "space-between",
    alignItems: "center"
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 320,
  },
  tableAction: {
    paddingLeft: 0,
    paddingRight: 0,
    margin: "0 auto",
    textAlign: "center",
    alignItems: "center"
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '600px',
    margin: 'auto'

  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: '10px'
  },
  paperContent: {
    backgroundColor: process.env.REACT_APP_PRIMARY_THEMA,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(1, 1, 1),
    borderRadius: '10px'
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  card: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(2),
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    borderRadius: '10px',
    height: '80px',
    marginTop: '-3%',
    marginBottom: '3.2%'
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  cardActions: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}));

export const ListClientes = ({ rows, openModalEdit, classes, changeRol, changeStatus, changeMachine, isLoanding }) => {
  const history = useHistory();
  const [id, setid] = useState("")
  const clases = useStyles()


  const validateRowsTable = (item) => {

    if (item !== undefined && item !== null) {
      return item
    } else {
      return "---"
    }

  }

  const Asignar = (row) => {

    setid(row.id)
    const params = {
      id: row.id,
      nombre: row.nombre
    };
    setTimeout(() => {

      history.push(`/Clientes/EvbisAsignadas`, params)
    }, 500);

  }



  return (

    <>


      {isLoanding ? <>Cargando...</> : rows.map((row) => (

        <Paper key={row.id} className={clases.card}>
          <Grid container spacing={1}>
            <Grid item style={{ width: '20.5%', fontWeight: "bold", fontSize: '17px' }}>
              {validateRowsTable(row.nombre)}
            </Grid>
            <Grid item style={{ width: '18%', fontWeight: "bold", fontSize: '17px' }}>
              {validateRowsTable(row.documento)}
            </Grid>
            <Grid style={{ width: '22%', fontWeight: "bold", fontSize: '17px' }}>
              {validateRowsTable(row.celular)}
            </Grid>
            <Grid  style={{ width: '14%', fontWeight: "bold", fontSize: '17px' }}>
              {validateRowsTable(row.estado != false ? 'Activo' : 'Inactivo')}
            </Grid>
            <Grid item xs={1}   onClick={() => { openModalEdit(row) }} setId={row}>
              <ListItem button  >
                <Tooltip title="Editar" aria-label="top-end" >
                  <CreateIcon color="primary" style={{ marginLeft: '30%' }} />
                </Tooltip>
              </ListItem>
            </Grid>
            <Grid item xs={1} onClick={() => { changeStatus(row) }}>
              <ListItem button >
                <Tooltip title={row.estado ? "Inhabilitar" : "Habilitar"} aria-label="top-end">
                  {row.estado ? <NotInterestedIcon color="primary" style={{ marginLeft: '30%' }} /> : <CheckCircleOutlineIcon color="primary" style={{ marginLeft: '30%' }} />}
                </Tooltip>
              </ListItem>
            </Grid>
            <Grid item xs={1} onClick={() => { Asignar(row) }}>
              <ListItem button >
                <Tooltip title="Estaciones" aria-label="top-end">
                  <CalendarViewDayIcon color="primary" style={{ marginLeft: '30%' }} />
                </Tooltip>
              </ListItem>
            </Grid>
          </Grid>
        </Paper>


      ))}


    </>
  )
}